<template>
  <div>
    <Form
      :description-title="'Atualize os dados deste setor'"
    >
      <Create
        @click="updateSector()"
        :icon="PhFilePlus"
        :label="'Atualizar'"
      />
    </Form>
  </div>
</template>

<script setup>
import Create from '@/components/Buttons/Create.vue'
import Form from '../components/SectorForm.vue'
import RcdService from '../service/rcd.service'
import { cleanAllFormFields, setFormFieldsError, validateFormField } from '@/helpers/formFieldsHandler'
import { showToast as toast } from '@/helpers/UseToasts'
import { PhFilePlus } from '@phosphor-icons/vue'
import { dataRcd } from '../store'
import { storeApp } from '@/store'
import * as yup from '@/validator'
import { ref } from 'vue'

const store = dataRcd.state
const appStore = storeApp.state
const id = ref(store.sectorForm.id)

const schema = yup.object().shape({
  sectorForm: yup.object().shape({
    name: yup.string().required('Informe o nome do setor').label('Tipo'),
    integrantes: yup.array().required('Informe ao menos um integrante').label('Integrante')
  })
})

async function updateSector () {
  appStore.loading = true
  cleanAllFormFields()

  const validate = (await validateFormField(schema, store))
  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  const data = store.sectorForm

  delete data.id
  delete data.email
  delete data.participantes

  await RcdService.updateSector(data, id.value)
    .then(res => {
      if (res.data.success) {
        appStore.loading = false
        dataRcd.dispatch('setSectors', res.data.setores)

        return toast(
          'Sucesso',
          res.data.message,
          'success'
        )
      }
    }).catch(err => {
      appStore.loading = false

      if (err?.response?.data?.error) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao atualizar setor',
        'error'
      )
    })
}
</script>
